module.exports = __webpack_public_path__ + "static/media/liyushanicon.dec98495.webp";